// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"d6a87588","455":"2178ac02","977":"c2ea0ac0"}[chunkId] + ".chunk.js";
};